var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"stepper is-size-7"},_vm._l((_vm.filteredRoutes),function(route,rI){return _c('router-link',{key:("basket-route-" + rI),attrs:{"to":route.to,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('li',{class:[
        _vm.$_.get(
          route,
          'isActive',
          function () { return isActive; }
        )(_vm.$router.currentRoute, isActive) && 'is-active',
        route.isDisabled && 'is-disabled'
      ]},[_c('a',_vm._g({class:[_vm.basketData.isProcessing && 'has-cursor-wait'],attrs:{"href":href}},Object.assign({}, (route.isDisabled || _vm.basketData.isProcessing
            ? { click: function ($e) { return $e.preventDefault(); } }
            : { click: navigate }))),[_c('span',[_vm._v(_vm._s(_vm.$t(route.label)))])])])]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }